<ion-toolbar mode="ios">
    <ion-buttons slot="start">
        <ion-back-button
            class="sub-headline-bold"
            text="{{ 'GLOBAL.HEADER.BACK_BUTTON' | translate }}"
            icon="arrow-back"
            defaultHref="/settings"
        ></ion-back-button>
    </ion-buttons>
    <ion-title class="sub-headline-bold" *ngIf="title">{{ title }}</ion-title>
    <ion-buttons *ngIf="icon" slot="end">
        <ion-button (click)="triggerAction()" [class.background]="background" [disabled]="disabled">
            <ion-icon
                *ngIf="displayIcon"
                [class.loader]="loader"
                slot="icon-only"
                [src]="icon"
                [color]="iconColor"
            ></ion-icon>
        </ion-button>
    </ion-buttons>
</ion-toolbar>
